export const products = [
    {
        id: 1, 
        title: 'Wax model of fruits',
        image: '/images/product2.png',
        price: 299,
        description: "Handmade diary made and binded by the best craftsmen from West Bengal",
        seller: "Kaushik",
    },
    {
        id: 2, 
        title: 'Jute Shoes',
        image: '/images/product3.png',
        price: 1099,
        description: "Handmade diary made and binded by the best craftsmen from West Bengal",
        seller: "Rishav",
    },
    {
        id: 3, 
        title: 'Wooden Toothbrushes',
        image: '/images/product4.png',
        price: 399,
        description: "Handmade diary made and binded by the best craftsmen from West Bengal",
        seller: "Vignesh",
    },
]

export const featuredProducts = [
    {
        id: 0, 
        title: 'Handmade Diary',
        image: '/images/product1.png',
        price: 499,
        description: "Handmade diary made and binded by the best craftsmen from West Bengal",
        seller: "Surya",
    },
]